import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import ContentWithRightSidebar from 'components/common/layout/ContentWithRightSidebar';
import { SIDEBAR_WIDTH } from 'components/common/layout/ContentWithRightSidebar/ContentWithRightSidebar.types';
import { resetAssetList } from 'store/pages/inventoryManagement/assetList/reducer';

import AssetContent from './AssetContent';
import AssetSidebar from './AssetSidebar';

const AssetList = (): React.ReactElement => {
  const dispatch = useDispatch();

  useEffect(() => {
    return (): void => {
      dispatch(resetAssetList());
    };
  }, []);

  return (
    <ContentWithRightSidebar content={<AssetContent />} sidebar={<AssetSidebar />} sidebarWidth={SIDEBAR_WIDTH.LARGE} />
  );
};

export default AssetList;
